"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cleanArray", {
  enumerable: true,
  get: function () {
    return _object.cleanArray;
  }
});
Object.defineProperty(exports, "getAnyFromArray", {
  enumerable: true,
  get: function () {
    return _object.getAnyFromArray;
  }
});
Object.defineProperty(exports, "getLastFromArrayOrObject", {
  enumerable: true,
  get: function () {
    return _object.getLastFromArrayOrObject;
  }
});
Object.defineProperty(exports, "getFirstFromSingleElementArrayNotNull", {
  enumerable: true,
  get: function () {
    return _object.getFirstFromSingleElementArrayNotNull;
  }
});
Object.defineProperty(exports, "getFirstFromSingleElementArray", {
  enumerable: true,
  get: function () {
    return _object.getFirstFromSingleElementArray;
  }
});
Object.defineProperty(exports, "isEmptyOrNull", {
  enumerable: true,
  get: function () {
    return _object.isEmptyOrNull;
  }
});
Object.defineProperty(exports, "isNotEmptyOrNull", {
  enumerable: true,
  get: function () {
    return _object.isNotEmptyOrNull;
  }
});
Object.defineProperty(exports, "verifyIfString", {
  enumerable: true,
  get: function () {
    return _object.verifyIfString;
  }
});
Object.defineProperty(exports, "isStringNotBlank", {
  enumerable: true,
  get: function () {
    return _object.isStringNotBlank;
  }
});
Object.defineProperty(exports, "truncateString", {
  enumerable: true,
  get: function () {
    return _object.truncateString;
  }
});
Object.defineProperty(exports, "omitDeepArrayWalk", {
  enumerable: true,
  get: function () {
    return _object.omitDeepArrayWalk;
  }
});
Object.defineProperty(exports, "omitDeep", {
  enumerable: true,
  get: function () {
    return _object.omitDeep;
  }
});
Object.defineProperty(exports, "removeDuplicates", {
  enumerable: true,
  get: function () {
    return _object.removeDuplicates;
  }
});
Object.defineProperty(exports, "resolveObj", {
  enumerable: true,
  get: function () {
    return _object.resolveObj;
  }
});
Object.defineProperty(exports, "concat", {
  enumerable: true,
  get: function () {
    return _object.concat;
  }
});
Object.defineProperty(exports, "getFirstElementOfArray", {
  enumerable: true,
  get: function () {
    return _object.getFirstElementOfArray;
  }
});
Object.defineProperty(exports, "flatten", {
  enumerable: true,
  get: function () {
    return _object.flatten;
  }
});
Object.defineProperty(exports, "isNotUndefOrNull", {
  enumerable: true,
  get: function () {
    return _object.isNotUndefOrNull;
  }
});
Object.defineProperty(exports, "flatMap", {
  enumerable: true,
  get: function () {
    return _object.flatMap;
  }
});

var _object = require("./object");